import { render, staticRenderFns } from "./liveManage.vue?vue&type=template&id=9724971e&"
import script from "./liveManage.vue?vue&type=script&lang=js&"
export * from "./liveManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9724971e')) {
      api.createRecord('9724971e', component.options)
    } else {
      api.reload('9724971e', component.options)
    }
    module.hot.accept("./liveManage.vue?vue&type=template&id=9724971e&", function () {
      api.rerender('9724971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/liveManage.vue"
export default component.exports